import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["header", "footer"];

  connect() {
    this.element.addEventListener("trix-initialize", () => {
      this._insertWrappingContent();
    });
  }

  _insertWrappingContent() {
    const toolbar = this.element.querySelector("trix-toolbar");
    const editor = this.element.querySelector("trix-editor");

    toolbar.insertAdjacentHTML("afterend", this.headerTarget.innerHTML);
    editor.insertAdjacentHTML("afterend", this.footerTarget.innerHTML);
  }
}
